/**
 * The bridge script injected into the native intake form WebView.
 * @module features/player-intake/utils/formBridgeScript
 */

/**
 * JavaScript injected into WebView to intercept Form.io submission events.
 *
 * SE-9160: every relayed message says whether it came from the renderer's
 * top-level document (`fromTopFrame`) and from which origin, because the host
 * answers a token refresh request only from that frame — the listener also
 * hears messages posted by any child frame. The host's own token refresh
 * replies are dispatched inside this page, so this listener sees them too;
 * they carry a credential and are neither logged nor relayed.
 */
export const INJECTED_JS = `
  (function() {
    var LOG_PREFIX = '[ScoutReport:FormBridge]';

    window.addEventListener('message', function(event) {
      try {
        var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        var type = data && data.type;
        if (type === 'formio_token_refresh' || type === 'formio_token_refresh_failed') return;
        console.log(LOG_PREFIX, 'Received postMessage:', JSON.stringify(data));
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'formio_message',
          payload: data,
          fromTopFrame: event.source === window,
          origin: event.origin
        }));
      } catch(e) {}
    });

    var originalFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      var options = arguments[1] || {};
      var method = (options.method || 'GET').toUpperCase();

      if (method === 'POST' || method === 'PUT') {
        console.log(LOG_PREFIX, 'Fetch intercepted:', method, typeof url === 'string' ? url.substring(0, 100) : 'non-string-url');
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'form_submission_attempt',
          payload: { method: method, url: typeof url === 'string' ? url.substring(0, 200) : 'unknown' }
        }));
      }

      return originalFetch.apply(this, arguments).then(function(response) {
        if (method === 'POST' || method === 'PUT') {
          window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'form_submission_response',
            payload: { status: response.status, statusText: response.statusText, url: typeof url === 'string' ? url.substring(0, 200) : 'unknown' }
          }));
        }
        return response;
      }).catch(function(err) {
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'form_submission_error',
          payload: { error: err.message }
        }));
        throw err;
      });
    };

    console.log(LOG_PREFIX, 'Form bridge initialized');
    window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'bridge_initialized'
    }));
    true;
  })();
`;
